import React from "react";
import "./Save.css";

const Save = () => {
  return (
    <div className="saveDiv">
      <div className="saveDescription">
        <h2>Save big with our cheap car rental!</h2>
        <p>
          Top Airports. Local Suppliers. <span>24/7</span> Support.
        </p>
      </div>
      <div className="saveImageContainer">
        {/* <img src={saveImg} alt="saveImg" /> */}
      </div>
    </div>
  );
};

export default Save;
